export const loadGoogleTagManagerNoScript = (gtmId: string) => {
    // Prevent duplicate injection
    if (document.getElementById('gtm-noscript')) return;

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    const container = document.createElement('div');
    container.id = 'gtm-noscript';

    const noscript = document.createElement('noscript');
    noscript.appendChild(iframe);

    container.appendChild(noscript);
    document.body.appendChild(container);
};
